module.exports = __webpack_public_path__ + "static/media/18ECA44.08dbdc73.jpg";